<template>
  <div v-if="user" class="user-info">
    <avatar :user="user" />
    <div class="user-mates">
      <div class="user-id">{{ user.userId }}</div>
      <div class="user-name">{{ user.nickname }}</div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/Avatar";
export default {
  components: { Avatar },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  display: flex;
  align-items: center;
  .user-mates {
    margin-left: 10px;
    .user-id {
      color: #555;
    }
    .user-name {
      color: #000;
      font-weight: 500;
    }
  }
}
</style>
